import { render, staticRenderFns } from "./PaidWeb.vue?vue&type=template&id=1497bab2&scoped=true&"
import script from "./PaidWeb.vue?vue&type=script&lang=js&"
export * from "./PaidWeb.vue?vue&type=script&lang=js&"
import style0 from "./PaidWeb.vue?vue&type=style&index=0&id=1497bab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497bab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1497bab2')) {
      api.createRecord('1497bab2', component.options)
    } else {
      api.reload('1497bab2', component.options)
    }
    module.hot.accept("./PaidWeb.vue?vue&type=template&id=1497bab2&scoped=true&", function () {
      api.rerender('1497bab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_adguard_landing/components/PaidModal/PaidWeb.vue"
export default component.exports